const apiEndPoints = {
  demoAPI: "https://jsonplaceholder.typicode.com/todos",
  registrationAPI: "users/register",
  userconfirmationAPI: "users/confirmUser",
  loginAPI: "users/login",
  verifyOtp: "users/verifyCode",
  linkValidation: "users/sendInviteeOTP",
  getRefreshToken: "users/getTokenRefreshed",
  downloadUtility: "webappscan/utility",
  securityStrength: "webappreports/securityStrength",
  scanSummary: "webappreports/scanSummary/",
  usagetype: "webappreports/usagetype/",
  deploymentType: "webappreports/deploymentType/",
  serverDistribution: "webappreports/serverDistribution/",
  globalDistribution: "webappreports/globalDistribution/",
  connectedServers: "webappreports/connectedServers/",
  threatCategories: "webappreports/threatCategories/",
  fileUpload: "webappusers/uploadinfo",
  securityIssues: "webappreports/securityIssues/",
  scanStatus: "webappscan/getScan",
  myScans: "webappscan/allScans",
  freeScans: "webappscan/allFreeScans",
  professionalScans: "webappscan/allScansUnderPP",
  oneTimeScans: "webappscan/allFreeScans",
  riskLevel: "webappreports/riskLevel/",
  connectedServerRiskLEvel: "webappreports/connRiskLevel/",
  scandetails: "webappscan/scanDetails/",
  shareReport: "webappscan/shareScan",
  cloudScan: "webappreports/cloudScan/",
  downloadScanReport: "webappreports/paidReport/",
  downLoadPaidReport: "webappreports/getDetailedReport/",
  dateRangeReport: "webappscan/generateDateRangeDetailedReportPDF",
  reportOTPProblem: "webappusers/createSupportRequest",
  allIntegrations: "webappusers/integrations",
  getKey: "webappscan/getKey/",
  getUploadUrl: "webappusers/getUploadURL",
  setScanInfo: "webappusers/uploadinfo",
  getSbcInfo: "webappusers/scheduleInfo",
  startScan: "webappusers/initiateScan",
  integrationSubscription: "webappusers/subscribeNotification",
  getScanConnectionStatus: "webappscan/getScanStatus/",
  setEMSConnection: "webappscan/setScanConfig",
  getSbcList: "webappscan/getScanConfig",
  selectedSBC: "webappscan/setScanConfig",
  getProductList: "webappusers/getProductList",
  getUserInfo: "webappusers/getUserInfo",
  signOut: "users/logout",
  getAllProducts: "webappusers/getAllProducts",
  setUserProfile: "webappusers/updateUserInfo",
  getUserProfile: "webappusers/getUserInfo",
  getInfraStructure: "webappscan/checkInfrastructureStatus",
  getScanProgress: "webappscan/getScanProgress",
  getScanSummary: "webappreports/scanSummary/",
  getScanStats: "webappusers/riskScoreForScan",
  getScanDetails: "webappscan/scanDetails/",
  getEMSConnection: "webappscan/getScanStatus/",
  getThreatVisibility: "webappreports/attackVisibility/",
  getScannedData: "webappreports/dataScanned/",
  getBreachData: "webappreports/breachIdentification/",
  getPolicyData: "webappreports/summaryStats/",
  getAttackOrigination: "webappreports/attackOrigination/",
  getScanNowTrending: "webappusers/getDashboardData",
  getSummaryReport: "webappreports/generateSummaryReportPDF/",
  getSchedule: "webappscan/getScheduleByUser",
  setSchedule: "webappscan/createSchedule",
  deleteSchedule: "webappscan/deleteSchedule",
  updateSchedule: "webappscan/updateSchedule",
  purchaseScan: "webappusers/purchaseLicenseSupport",
  setTimelineView: "webappusers/fetchTimeLineView",
  setExecutiveSummary: "webappusers/fetchExecutiveSummary",
  downloadLinuxUtility: "webappscan/linuxUtility",
  linuxUtilityGuide: "webappscan/linuxUtilityGuide",
  getScanStateOne: "webappusers/fetchRiskProfile",
  setVerticalTimelineView: "webappusers/fetchTimeLineViewVertical",
  avayaDownloadLinuxUtility: "webappscan/downloadLinuxUtility",
  viewSchedules: "webappusers/viewSchedules",
  resetSchedules: "webappscan/deleteSchedule",
  editSchedules: "webappscan/updateSchedule",
  userLicenses: "webappusers/findLicensesOfUser",
  operationDashboard: "webappscan/fetchOperationsDashboard",
  verifySbcPassword: "webappscan/verifySbcPassword",
  attackDisposition: "webappreports/attacksDisposition",
  visibility: {
    robocalls: "webappreports/robocallsGraph/",
    vishing: "webappreports/userImpactedRobocallGraph/",
    incomingCalls: "webappreports/incomingCalls",
    tollFreeData: "webappreports/tollFreePumping",
    tollFraud: "webappreports/tollFraud",
    top5ScamCallers: "webappreports/top5SpamTargetNumbers",
    top5TargetNumbers: "webappreports/top5TargetNumbers",
    callOriginations: "webappreports/callOriginations",
    outboundBlocked: "webappreports/outboundBlockedCalls",
  },
  whitelist: "webappdefender/whitelist",
  blacklist: "webappdefender/blacklist",
  spam: "webappdefender/update-feedback",
  scam: "webappdefender/update-feedback",
  updateFeedback: "webappdefender/update-feedback",
  addSpam: "webappdefender/report-number",
  addScam: "webappdefender/report-number",
  reportNumber: "webappdefender/report-number",
  approveNumber: "webappdefender/approve-number",
  getReputationLog: "defender/getReputationLog",
  enforcement: {
    inboundTrafficEnforcement: "webappreports/inboundTrafficEnforcement",
    enforcementDashBoardStats: "webappreports/enforcementDashBoardStats",
  },
  securityIncidents: "webappusers/fetchSecurityIncidents",
  telemetrySecurityIncidents: "webappusers/fetchTelemetrySecurityIncidents",
  getDefenderDeviceConfig: "workflow/getDeviceConfigurationForUI",
  getBotScreenerAnalytics: "workflow/getBotScreenerAnalytics",
  getBotScreenerDetails: "workflow/getBotScreenerDetails",
  updateBotScreenerSequence: "workflow/updateBotScreenerSequence",
  updateDeviceLocation: "workflow/updateDeviceLocation",
  updateDeviceIps: "workflow/updateDeviceIps",
  updateDeviceName: "workflow/updateDeviceName",
  deleteDefender: "workflow/deleteDefender",
  actionsToBeTakenNums: "workflow/actionsToBeTakenNums",
  getBotScreenerPassFailCounts: "workflow/getBotScreenerPassFailCounts",
  updateDefenderDeviceConfig: "webappusers/updateDeviceConfiguration",
  getScannerConfig: "webappreports/getScannerConfigurationStatus",
  updateScannerConfig: "webappreports/updateScannerConfiguration",
  getDefenderId: "webappusers/getDefenderdetails",
  getCustomerId: "webappusers/getCustomerId",
  registrationScreened: "webappreports/registrations-screened",
  remoteWorkerSecurity: "webappreports/remoteWorkerSecurity",
  getRealTimeScans: "webappreports/getRealTimeScans",
  editDefenderName: "webappreports/editDefenderName",
  getUserType: "webappreports/getUserType",
  getPartnerStats: "webappreports/getPartnerViewStats",
  remoteWorkerTraffic: "webappreports/remoteWorkerSecurity",
  associateUserTocustomer: "webappreports/associateUserToCustomer",
  getUsers: "webappreports/getUsers",
  deleteUserFromCustomer: "webappreports/deleteUserFromCustomer",
  apiKeys: "webappreports/apiKeys",
  requestKey: "webappreports/requestKey",
  editAiSettings: "webappreports/editAiSettings",
  getAiSettings: "webappreports/getAiSettings",
  getvoiceInfraSettings: "webappreports/getvoiceInfraSettings",
  updatevoiceInfraSettings: "webappreports/updatevoiceInfraSettings",
  serviceNumbers: "webappreports/serviceNumbers",
  getServiceNumbers: "webappscan/getServiceNumbers",
  assertionPopulatedList: "webappreports/assertionPopulatedList",
  addAllowDenyOutBound: "webappreports/addAllowDenyOutBound",
  getAllowDenyOutBound: "webappreports/getAllowDenyOutBound",
  deleteAllowDenyOutBound: "webappreports/deleteAllowDenyOutBound",
  editAllowDenyOutBound: "webappreports/editAllowDenyOutBound",
  getOrigRemoteIps: "webappreports/getOrigRemoteIps",
  deleteVoiceInfra: "webappreports/deleteVoiceInfra",
  categoriesGraph: "webappreports/categoriesGraph",
  getEsIndexByAlias: "webappreports/getEsIndexByAlias",
  updateEsIndexByAlias: "webappreports/updateEsIndexByAlias",
  telcoViewGraph: "webappreports/telcoViewGraph",
  serviceNumberGraph: "webappreports/serviceNumberGraph",
  top5ScamExport: "webappreports/top5ScamExport",
  outboundWorldMap: "webappreports/outboundWorldMap",
  getSbcInterfaceMappings: "webappreports/getSbcInterfaceMappings",
  getSbcNameRegion: "webappreports/getSbcNameRegion",
  saveSbcNameRegion: "webappreports/saveSbcNameRegion",
  getSourceIPs: "webappreports/getSourceIPs",
  getScannerIds: "webappreports/getScannerIds",
  saveSbcInterfaceMappings: "webappreports/saveSbcInterfaceMappings",
  remoteWorkerCount: "webappreports/remoteWorkerCount",
  remoteWorkerTopAttackers: "webappreports/remoteWorkerTopAttackers",
  remoteWorkerEndpointBruteForce:
    "webappreports/remoteWorkerEndpointBruteForce",
  ipInfo: "webappreports/ipInfo",
  remoteWorkerTrafficGraph: "webappreports/remoteWorkerTraffic",
  exportCCServiceNumberDetails: "webappreports/exportCCServiceNumberDetails",
  telcoCps: "webappscan/telcoCpsGraph",
  vishingGraphViewDetails: "webappreports/vishingGraphViewDetails",
  confidenceScoresHistory: "scan/confidenceScoresHistory",
  updateSecurityIncidentEmails: "webappscan/updateSecurityIncidentEmails",
  getPartnerViewAlertStats: "webappscan/getPartnerViewAlertStats",
  activeSecurityIncidents: "webappscan/getactiveSecurityIncidents",
  aiCategories: "scan/getaiCategories",
  updatenumberNormalization: "scan/updatenumberNormalization",
  inboundCauseCodeGraph: "webappscan/inboundCauseCodeGraph",
  inboundCauseCodeGraphViewDetails:
    "webappscan/inboundCauseCodeGraphViewDetails",
  invalidToNumberType: "webappscan/invalidToNumberType",
  dncCallRestrictionList: "webappscan/dncCallRestrictionList",
  updateTDoSThreshold: "webappscan/updateTDoSThreshold",
  updateAiAlogsConfig: "webappscan/updateAiAlogsConfig",
  getDefenderHADetails: "webappscan/getDefenderHADetails",
  getScannersDetails: "webappscan/getScannersDetails",
  fetchHorizontalTimelineViewFromEs: "scan/fetchHorizontalTimelineViewFromEs",
  updateWorkFlowManagers: "webappscan/updateWorkFlowManagers",
  makeScannerPrimary: "webappscan/makeScannerPrimary",
  getTriggeredActivities: "webappscan/getTriggeredActivities",
  updateProcessNames: "webappscan/updateProcessNames",
  getFeatureLicenseData: "webappscan/getFeatureLicenseData",
  getMonthlySessionsData: "webappscan/getMonthlySessionsData",
  getServiceUptimeStatus: "webappscan/getServiceUptimeStatus",
  blockZoneDetails: "webappscan/blockZoneDetails",
  getUserExtensionRanges: "webappscan/getUserExtensionRanges",
  saveTransferedExensionRanges: "webappscan/saveTransferedExensionRanges",
  newDashboardStats: "webappscan/newDashboardStats",
  callScreenedStats: "webappscan/callScreenedStats",
  callScreenedTableStats: "webappscan/callScreenedTableStats",
  remoteWorkerSecurityStats: "webappscan/remoteWorkerSecurityStats",
  extensionPopData: "webappscan/extensionPopData",
  remoteWorkerWorldMap: "webappscan/remoteWorkerWorldMap",
  splitByAttackPopUp: "webappscan/splitByAttackPopUp",
  getConfigurationIssuesData: "webappscan/getConfigurationIssuesData",
  getCloudPostureIssuesData: "webappscan/getCloudPostureIssuesData",
  getScanIds: "webappscan/getScanIds",
  remoteWorkerDashboardStats: "webappscan/remoteWorkerDashboardStats",
  callHistoryOfNumber: "webappscan/callHistoryOfNumber",
  aiInsights: "webappscan/aiInsights",
  attackersSplit: "webappscan/attackersSplit",
  callTrafficAnalysis: "webappscan/callTrafficAnalysis",
  getSbcMetadata: "webappscan/getSbcMetadata",
  callsDefendedDetails: "webappscan/callsDefendedDetails",
  splitByAttackEvidenceData: "webappscan/splitByAttackEvidenceData",
  remoteWorkerTopAttackersByIpPopUp:
    "webappscan/remoteWorkerTopAttackersByIpPopUp",
  exportextensionPopData: "webappscan/exportextensionPopData",
  getRemoteWorkerRegexRanges: "webappscan/getRemoteWorkerRegexRanges",
  getSuspiciousIpDetected: "users/fetchSuspiciousIpDetected",
  getExtensionRangesDetected: "users/fetchExtensionRangesDetected",
  getUserAgentsDetected: "users/fetchUserAgentsDetected",
  suspiciousIpNotAnAttacker: "users/suspiciousIpNotAnAttacker",
  getProcessList: "users/getProcessList",
  getCmsNotification: "users/updateCmsNotification",
  updateIncidentState: "scan/updateIncidentState",
  campaigns: "/scan/campaigns",
  ani: "/scan/aniList",
  campaignMapping: "/scan/campaign-mappings",
  getLocalAniReplacement: "/users/getLocalAniReplacement",
  updateSecurityIncidentStatus: "/users/updateSecurityIncidentStatus",
  getWorkflowSectionGraphsData: "/scan/getWorkflowSectionGraphsData",
  getExportJobsData: "/scan/getExportJobsData",
  getScannerLogFiles: "/scan/getScannerLogFiles",
  getDefenderLogFiles: "/scan/getDefenderLogFiles",
  createDefenderLogRequest: "workflow/createDefenderLogRequest",
  getMonthlySessionsDataForLicense: "workflow/getMonthlySessionsDataForLicense",
  getGeoFencingDetails: "/workflow/getGeoFencingDetails",
  geoFencingHandler: "/workflow/geoFencingHandler",
  licenseHandler: "/workflow/licenseHandler",
  getUserLicenses: "webappusers/getLicensesOfUser",
  remoteAlerts: "workflow/updateCmsAlerts",
  scheduledReports: "/workflow/emailScheduleHandler",
  updatePatientRoomConfig: "workflow/updatePatientRoomConfig",
  getPatientRoomData: "/workflow/getPatientRoomData",
  getAllowListPatientRoomData: "/workflow/getAllowListPatientRoomData",
  getTopTenAttackerDetails: "/workflow/getTopTenAttackerDetails",
  getSecurityIncidentsData: "/workflow/getSecurityIncidentsData",
  handleDncProviderConfig: "workflow/handleDncProviderConfig",
  handleDncArchiveConfig: "workflow/handleDncArchiveConfig",
  getDncWorkflowData: "workflow/getDncWorkflowData",
  manageHealthAlertRecipients: "/workflow/manageHealthAlertRecipients",
  manageBotScreenerHealthThresholds:
    "/workflow/manageBotScreenerHealthThresholds",
  manageDefenderHealthThresholds: "/workflow/manageDefenderHealthThresholds",
  getActiveThresholds: "/workflow/getActiveThresholds",
  manageAuditReportRecipients: "/workflow/manageAuditReportRecipients",
  handleScreenerDestinationNumbers:
    "/workflow/handleScreenerDestinationNumbers",
  getCallCounters: "workflow/getCallCounters",
};

export { apiEndPoints };
